import { HttpInterceptorFn } from '@angular/common/http';

/**
 * Adds transaction metadata to all outgoing API requests.
 */
export const transactionHeadersInterceptor: HttpInterceptorFn = (req, next) => {
  const requestWithHeaders = req.clone({
    setHeaders: {
      transactionid: crypto.randomUUID(),
      transactionsource: 'GRERS'
    }
  });

  return next(requestWithHeaders);
};
